import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isEmpty from "lodash/isEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useHistory, useQueryParams } from '@atlassian/mpac-ui';
import queryString from 'query-string';
import { filtersAnalyticsConfig } from '../PartnerReports.events';
import { getNewReportPathname, getNewSearch } from './ReportFilters.utils';
function useQueryParamsUpdate(partnerId, reportName) {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const queryParams = useQueryParams();
  const history = useHistory();
  const getUpdatedFilterGroup = (selectedOptionValue, selectedOptionQueryParam, filterGroupObject) => {
    /**
     * Special filter object  needs to be sent for all dates, to have default
     * selection of dateType, start and end dates.
     * This is needed because all dates doesn't have period value.
     */
    if (selectedOptionQueryParam !== 'period' || selectedOptionValue) {
      return filterGroupObject;
    }
    if (reportName === 'licenses') {
      return {
        [selectedOptionQueryParam]: selectedOptionValue,
        dateType: null,
        startDate: null,
        endDate: null
      };
    } else {
      return {
        [selectedOptionQueryParam]: selectedOptionValue
      };
    }
  };
  const updateQueryParams = _ref => {
    let {
      selectedOptionValue,
      selectedOptionQueryParam,
      shouldAppendUrl,
      filterGroupObject,
      label
    } = _ref;
    const updatedFilterGroup = getUpdatedFilterGroup(selectedOptionValue, selectedOptionQueryParam, filterGroupObject);
    if (updatedFilterGroup) {
      let searchParams = {};
      let queryParamSearch;
      for (const queryParam in updatedFilterGroup) {
        var _queryParams$queryPar;
        queryParamSearch = getNewSearch(queryParams, queryParam, updatedFilterGroup[queryParam], true);
        searchParams = _objectSpread(_objectSpread(_objectSpread({}, queryParamSearch), searchParams), {}, {
          [queryParam]: queryParamSearch[queryParam]
        });
        const queryParamVal = (_queryParams$queryPar = queryParams[queryParam]) !== null && _queryParams$queryPar !== void 0 ? _queryParams$queryPar : '';
        const filterGroupObjectParamVal = _isEmpty(updatedFilterGroup[queryParam]) ? '' : updatedFilterGroup[queryParam];

        /**
         * We need to fire this event for each query param in the More Filter bucket.
         * Hence in the loop itself We are running it on every query param.
         */

        if (filterGroupObjectParamVal !== queryParamVal) {
          fireAnalyticsEvent(filtersAnalyticsConfig(_objectSpread({
            partnerId,
            reportName,
            value: updatedFilterGroup[queryParam],
            label: label
          }, {
            queryParam
          })));
        }
      }
      history === null || history === void 0 ? void 0 : history.push({
        pathname: getNewReportPathname(partnerId, reportName, false, ''),
        search: queryString.stringify(searchParams)
      });
      return;
    }
    if (selectedOptionQueryParam) {
      var _queryParams$selected;
      const queryParamVal = (_queryParams$selected = queryParams[selectedOptionQueryParam]) !== null && _queryParams$selected !== void 0 ? _queryParams$selected : '';
      if ((selectedOptionValue !== null && selectedOptionValue !== void 0 ? selectedOptionValue : '') !== queryParamVal) {
        fireAnalyticsEvent(filtersAnalyticsConfig(_objectSpread({
          partnerId,
          reportName,
          value: selectedOptionValue,
          label: label
        }, selectedOptionQueryParam ? {
          queryParam: selectedOptionQueryParam
        } : {})));
      }
    }
    history === null || history === void 0 ? void 0 : history.push({
      pathname: getNewReportPathname(partnerId, reportName, shouldAppendUrl, selectedOptionValue),
      search: getNewSearch(queryParams, selectedOptionQueryParam, selectedOptionValue)
    });
  };
  return {
    updateQueryParams
  };
}
export default useQueryParamsUpdate;